import { Box, BoxProps } from "@chakra-ui/react";

export const PAGE_SECTION_PADDING_X = [
  "1rem",
  "2rem",
  "3rem",
] as const satisfies BoxProps["px"];

export const PAGE_SECTION_PADDING_Y = [
  "1rem",
  "2rem",
] as const satisfies BoxProps["py"];

type NegativePadding<T extends string> = `calc(-1 * ${T})`;

function getNegativePadding<T extends string>(padding: T[]) {
  return padding.map<NegativePadding<T>>((value) => `calc(-1 * ${value})`);
}

export const NEGATIVE_PAGE_SECTION_PADDING_X = getNegativePadding(
  PAGE_SECTION_PADDING_X,
);
export const NEGATIVE_PAGE_SECTION_PADDING_Y = getNegativePadding(
  PAGE_SECTION_PADDING_Y,
);

type Props = BoxProps & {
  isUnpadded?: boolean;
};

export default function PageSection({
  children,
  isUnpadded = false,
  ...rest
}: Props) {
  return (
    <Box
      as="section"
      px={isUnpadded ? undefined : PAGE_SECTION_PADDING_X}
      py={isUnpadded ? undefined : PAGE_SECTION_PADDING_Y}
      {...rest}
    >
      {children}
    </Box>
  );
}
